/* OutIn — mobile carousel dots + trust-badge marquee + featured card design on
   collection/search product cards. Idempotent; re-runs on Shopify section load
   and on filter/infinite-scroll DOM updates. Pairs with outin-carousel.css. */
(function(){
  var SCROLLERS = '.outin-cards--carousel, .outin-life--swipe-m, .outin-journal, .outin-intro__collage';

  /* ----- Trust badge marquee ----- */
  function buildMarquee(root){
    (root || document).querySelectorAll('.outin-trust').forEach(function(grid){
      if (grid.__outinMarq) return;
      var items = Array.prototype.slice.call(grid.querySelectorAll('.outin-trust__item'));
      if (items.length < 2) return;
      grid.__outinMarq = true;
      var wrap = document.createElement('div');
      wrap.className = 'outin-trust-marquee';
      var track = document.createElement('div');
      track.className = 'outin-trust-marquee__track';
      items.forEach(function(it){ track.appendChild(it.cloneNode(true)); });
      items.forEach(function(it){ var c = it.cloneNode(true); c.setAttribute('aria-hidden','true'); c.setAttribute('tabindex','-1'); track.appendChild(c); });
      wrap.appendChild(track);
      grid.parentNode.insertBefore(wrap, grid.nextSibling);
      wrap.style.setProperty('--outin-marq-dur', (items.length * 6) + 's');
      grid.classList.add('outin-trust--marqueed');
    });
  }

  /* ----- Dotted pagination ----- */
  function buildDots(root){
    (root || document).querySelectorAll(SCROLLERS).forEach(function(scroller){
      if (scroller.__outinDots) return;
      var items = Array.prototype.slice.call(scroller.children);
      if (items.length < 2) return;
      scroller.__outinDots = true;
      scroller.classList.add('outin-scroller--dotted');
      var nav = document.createElement('div');
      nav.className = 'outin-dots';
      if (scroller.closest('.outin-bg-moss')) nav.classList.add('outin-dots--on-dark');
      var dots = items.map(function(it, i){
        var b = document.createElement('button');
        b.type = 'button';
        b.className = 'outin-dots__dot';
        b.setAttribute('aria-label', 'Go to item ' + (i + 1));
        b.addEventListener('click', function(){ it.scrollIntoView({ behavior: 'smooth', inline: 'center', block: 'nearest' }); });
        nav.appendChild(b);
        return b;
      });
      scroller.parentNode.insertBefore(nav, scroller.nextSibling);
      var ticking = false;
      function update(){
        ticking = false;
        var sr = scroller.getBoundingClientRect();
        var center = sr.left + sr.width / 2, best = Infinity, idx = 0;
        items.forEach(function(it, i){
          var r = it.getBoundingClientRect();
          var d = Math.abs((r.left + r.width / 2) - center);
          if (d < best){ best = d; idx = i; }
        });
        dots.forEach(function(d, i){ d.classList.toggle('is-active', i === idx); });
      }
      scroller.addEventListener('scroll', function(){ if (!ticking){ ticking = true; requestAnimationFrame(update); } }, { passive: true });
      window.addEventListener('resize', function(){ requestAnimationFrame(update); });
      update();
    });
  }

  /* ----- Featured card design on Horizon product cards (collection/search only) ----- */
  function validCardTemplate(){
    var main = document.getElementById('MainContent');
    var tpl = main ? (main.getAttribute('data-template') || '') : '';
    return tpl.indexOf('collection') === 0 || tpl === 'list-collections' || tpl.indexOf('search') === 0;
  }
  function applyCardDesign(root){
    if (!validCardTemplate()) return;
    (root || document).querySelectorAll('.product-card__content').forEach(function(content){
      if (content.__outinCard) return;
      var kids = Array.prototype.slice.call(content.children);
      if (!kids.length) return;
      var media = null;
      for (var i = 0; i < kids.length; i++){
        var k = kids[i];
        if (/gallery|media/i.test(k.className || '') || k.querySelector('img,svg,video')){ media = k; break; }
      }
      if (!media) media = kids[0];
      content.__outinCard = true;
      content.classList.add('outin-hcard');
      var info = document.createElement('div');
      info.className = 'outin-hcard__info';
      kids.forEach(function(k){ if (k !== media) info.appendChild(k); });
      if (info.childNodes.length) content.appendChild(info);
    });
  }
  function setupCardObserver(){
    if (!validCardTemplate()) return;
    var main = document.getElementById('MainContent');
    if (!main || main.__outinCardObs) return;
    main.__outinCardObs = true;
    var scheduled = false;
    var mo = new MutationObserver(function(){
      if (scheduled) return;
      scheduled = true;
      requestAnimationFrame(function(){ scheduled = false; applyCardDesign(document); });
    });
    mo.observe(main, { childList: true, subtree: true });
  }

  function init(root){
    try { buildMarquee(root); } catch(e){}
    try { buildDots(root); } catch(e){}
    try { applyCardDesign(root); } catch(e){}
  }

  if (document.readyState !== 'loading'){ init(document); setupCardObserver(); }
  else document.addEventListener('DOMContentLoaded', function(){ init(document); setupCardObserver(); });
  document.addEventListener('shopify:section:load', function(e){ init(e.target); });
})();
